export default Object.freeze({
 ENV: {
   JPN: 'JPN', // 日本環境
   CHN: 'CHN'  // 中国環境
 },
 USER_KBN: {
   DEVELOP: 'developer',                     // 開発者ユーザ
   SALES: 'ap-northeast-1_MdNhxehUD_KITORA'  // 販売店ユーザ
 },
 CALENDER_DAYS: {
   DAY_DEFAULT: 7,
   DAY_LIMIT: 29
 },
 STATUS: {
   NOT_REQUESTED: '1',
   SUBMITTED: '2',
   PENDING: '3',
   NOT_CONFIRMED: '11',
   CONFIRMED: '12'
 },
 SEARCH: {
   MAX_RECORD: 500,
   ERROR: {
     NOT_ERROR: 0,
     INPUT_ERROR: 1,
     SEARCH_ERROR: 2,
     NETWORK_ERROR: 3,
     ZENDESK_ERROR: 4,
     RESULT_0_ERROR: 11,
     RESULT_MAX_ERROR: 12
   }
 },
 IMAGE: {
   FILES: 'Files',
   KEY: 'Key'
 },
 ACTION_MODE: {
   SEARCH: 'search',
   DETAIL: 'detail',
   SUBMITTED: 'submit',
   PENDING: 'pending'
 }
});
